import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { getTestLabels } from '../../../utils/getTestLabels.js';
import textInputStyle from '../style/text-input.module.scss.js';
import style from './Textarea.module.scss.js';

const { componentTestLabel } = getTestLabels('Textarea');
/**
 * [design (Figma)](https://www.figma.com/design/MUnGlxUUspXSbRkFsEXWGQ/%F0%9F%92%A0-Core-Components?node-id=2718-4368&node-type=section&t=L12XIxh9aK1lGzgC-0)
 * | [source code](https://src.private.zooplus.net/projects/FE/repos/ui-components/browse/src/components/Form/Textarea/Textarea.tsx)
 *
 * @param {boolean} hasError - (optional) Set to `true` when the textarea element is in an error state. Applies visual error styling.
 */
const Textarea = forwardRef((props, ref) => {
    const { children, className, disabled, hasError = false, ...otherProps } = props;
    return (jsx("textarea", { "data-zta": componentTestLabel, ref: ref, ...otherProps, disabled: disabled, className: classNames(textInputStyle['z-text-input'], style['z-textarea'], {
            [textInputStyle['z-text-input--error']]: hasError,
        }, className), children: children }));
});
Textarea.displayName = 'Textarea';

export { Textarea };
//# sourceMappingURL=Textarea.js.map
